var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),(_vm.isCheckingSeasonGoal)?_c('main',{staticClass:"main"},[_vm._m(0)]):_c('SeasonComponent'),_c('Footer')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section"},[_c('div',{staticClass:"season-start-loader"},[_c('span',{staticClass:"season-start-loader__spinner"})])])
}]

export { render, staticRenderFns }